import { render, staticRenderFns } from "./TransferProductsList.vue?vue&type=template&id=0251cbc8&"
import script from "./TransferProductsList.vue?vue&type=script&lang=js&"
export * from "./TransferProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports